import { motion } from "framer-motion";
import { useMemo } from "react";
import certLogo from "@/assets/cert-logo-m.png.asset.json";
import { useTranslation } from "react-i18next";


const ManifestoSection = () => {
  const { t } = useTranslation();
  const dots = useMemo(
    () =>
      Array.from({ length: 60 }).map(() => ({
        top: Math.random() * 100,
        left: Math.random() * 100,
        delay: Math.random() * 4,
        duration: 2.5 + Math.random() * 3,
      })),
    []
  );

  return (
    <section data-header-theme="blue" className="relative overflow-hidden bg-black py-14 md:py-24">
      {/* pixel starfield */}
      <div aria-hidden className="pointer-events-none absolute inset-0">
        {dots.map((d, i) => (
          <motion.span
            key={i}
            className="absolute block h-[3px] w-[3px] bg-white"
            style={{ top: `${d.top}%`, left: `${d.left}%`, boxShadow: "0 0 6px rgba(255,255,255,0.9)" }}
            animate={{ opacity: [0.45, 1, 0.45] }}
            transition={{
              duration: d.duration,
              delay: d.delay,
              repeat: Infinity,
              ease: "linear",
            }}
          />
        ))}
      </div>

      <div className="relative mx-auto max-w-5xl px-4 sm:px-6">
        <div className="space-y-8 text-center">
          <p
            className="font-dot text-sm leading-relaxed sm:text-base tracking-tight text-brand-blue md:text-xl md:leading-[1.75]"
          >
            {t("sHome.manifestoSection.paragraph")}
          </p>
          <div
            className="flex flex-wrap items-center justify-center gap-8 pt-6 md:gap-12"
          >
            <a
              href="https://grupomoure.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("sHome.manifestoSection.logoAria")}
              className="transition-opacity hover:opacity-70"
            >
              <img
                src={certLogo.url}
                alt={t("sHome.manifestoSection.logoAlt")}
                loading="lazy"
                className="h-16 w-auto sm:h-20 md:h-20"
              />
            </a>
          </div>


        </div>
      </div>
    </section>
  );
};

export default ManifestoSection;
